import { render } from "./TabletComponent.vue?vue&type=template&id=51edfb0c&scoped=true"
import script from "./TabletComponent.vue?vue&type=script&lang=js"
export * from "./TabletComponent.vue?vue&type=script&lang=js"

import "./TabletComponent.vue?vue&type=style&index=0&id=51edfb0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51edfb0c"]])

export default __exports__